import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Box } from '@components/Box';
import { Button } from '@components/Button';
import { getCreateWeddingUrl } from '@utils/urlHelpers.util';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { Avatar } from '@components/Avatar';
import { useGuestListStaticHeroController } from './GuestListStaticHero.controller';
import {
  GuestListHeroSection,
  StyledTextPairing,
  StyledBox,
  StyledAvatarsBox,
  StyledTextWrapper,
  StyledIconBox,
  StyledLottieBox,
  StyledLottieContainerBox,
  StyledText,
  StyledSideBox,
  StyledSideCloudImage,
  StyledHeroTopBox,
  StyledHeroTopCloudImage,
  StyledLeftHeroBox,
  StyledRightHeroBox,
  StyledLeftHeroAvatar,
  StyledRightHeroAvatar,
} from './GuestListStaticHeroSection.styles';
import { useTranslation } from 'react-i18next';

export const GuestListStaticHeroSection: React.FC = () => {
  const { t } = useTranslation('guestList');
  const connectedGuestListData = t('connectedGuestList');

  const heroTopAssetsLeft = [
    {
      isLeft: true,
      image: 'guest-list/hero-vid/avatar-art/hero-curl.svg',
      top: '-450px',
      offset: '25px',
      width: 306,
      height: 632,
    },
    {
      isLeft: true,
      image: 'guest-list/hero-vid/avatar-art/hero-grid.svg',
      top: '-218px',
      offset: '25px',
      width: 375,
      height: 375,
    },
    {
      isLeft: true,
      image: 'guest-list/hero-vid/avatar-art/hero-red-dot.svg',
      top: '-80px',
      offset: '282px',
      width: 66,
      height: 67,
    },
  ];

  const heroTopAssetsRight = [
    {
      isLeft: false,
      image: 'guest-list/hero-vid/avatar-art/hero-blob.svg?opt=aggressive',
      top: '-250px',
      offset: '-445px',
      width: 961,
      height: 959,
    },
    {
      isLeft: false,
      image: 'guest-list/hero-vid/avatar-art/hero-burst.svg?opt=aggressive',
      top: '-225px',
      offset: '-50px',
      width: 371,
      height: 371,
    },
    {
      isLeft: false,
      image: 'guest-list/hero-vid/avatar-art/hero-square.svg?opt=aggressive',
      top: '-325px',
      offset: '-175px',
      width: 38,
      height: 38,
    },
    {
      isLeft: false,
      image: 'guest-list/hero-vid/avatar-art/hero-textured-shape.svg?opt=aggressive',
      top: '-480px',
      offset: '-75px',
      width: 171,
      height: 196,
    },
  ];

  const listItemAvatarLeft = [
    // Left
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-23.jpg?resize=w156&opt=aggressive',
      sizeVariant: 160,
      resSizeVariant: 70,
      top: '-340px',
      resTop: '105px',
      left: '-68px',
      resLeft: '-5%',
    },
    {
      type: 'tag',
      avatarUrl: `${connectedGuestListData.tagAList}?resize=w56&opt=aggressive`,
      sizeVariant: 60,
      resSizeVariant: 70,
      top: '-322px',
      resTop: '105px',
      left: '68px',
      resLeft: '-5%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-1.jpg?resize=w152&opt=aggressive',
      sizeVariant: 156,
      resSizeVariant: 70,
      top: '-300px',
      resTop: '60px',
      left: '134px',
      resLeft: '97%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-5.jpg?resize=w151&opt=aggressive',
      sizeVariant: 155,
      resSizeVariant: 75,
      top: '-120px',
      resTop: '5px',
      left: '10px',
      resLeft: '0',
    },
    {
      type: 'tag',
      avatarUrl: `${connectedGuestListData.tagVegetarian}?resize=w155&opt=aggressive`,
      sizeVariant: 159,
      resSizeVariant: 75,
      top: '-195px',
      resTop: '5px',
      left: '87px',
      resLeft: '0',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-9.jpg?resize=w96&opt=aggressive',
      sizeVariant: 100,
      resSizeVariant: 70,
      top: '-50px',
      resTop: '105px',
      left: '200px',
      resLeft: '-5%',
    },
    {
      type: 'tag',
      avatarUrl: `${connectedGuestListData.tagOutOfTown}?resize=w139&opt=aggressive`,
      sizeVariant: 143,
      resSizeVariant: 70,
      top: '-61px',
      resTop: '105px',
      left: '270px',
      resLeft: '-5%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-3.jpg?resize=w180&opt=aggressive',
      sizeVariant: 184,
      resSizeVariant: 85,
      top: '-215px',
      resTop: '50px',
      left: '-305px',
      resLeft: '50%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-2.jpg?resize=w92&opt=aggressive',
      sizeVariant: 96,
      resSizeVariant: 100,
      top: '-90px',
      resTop: '0px',
      left: '-410px',
      resLeft: '-100%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-1.jpg?resize=w147&opt=aggressive',
      sizeVariant: 151,
      resSizeVariant: 70,
      top: '30px',
      resTop: '60px',
      left: '-370px',
      resLeft: '97%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-9.jpg?resize=w139&opt=aggressive',
      sizeVariant: 143,
      resSizeVariant: 70,
      top: '-15px',
      resTop: '105px',
      left: '-157px',
      resLeft: '-5%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-7.jpg?resize=w117&opt=aggressive',
      sizeVariant: 121,
      resSizeVariant: 65,
      top: '190px',
      resTop: '225px',
      left: '-170px',
      resLeft: '0%',
    },
  ];

  // Right
  const listItemAvatarRight = [
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-9.jpg?resize=w96&opt=aggressive',
      sizeVariant: 100,
      resSizeVariant: 70,
      top: '-410px',
      resTop: '225px',
      left: '-280px',
      resLeft: '93%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-4.jpg?resize=w151&opt=aggressive',
      sizeVariant: 155,
      resSizeVariant: 75,
      top: '-285px',
      resTop: '5px',
      left: '-105px',
      resLeft: '82%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-3.jpg?resize=w180&opt=aggressive',
      sizeVariant: 184,
      resSizeVariant: 85,
      top: '-295px',
      resTop: '50px',
      left: '65px',
      resLeft: '50%',
    },
    {
      type: 'tag',
      avatarUrl: `${connectedGuestListData.tagRehearsal}?resize=w139&opt=aggressive`,
      sizeVariant: 143,
      resSizeVariant: 85,
      top: '-245px',
      resTop: '50px',
      left: '186px',
      resLeft: '50%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-4.jpg?resize=w129&opt=aggressive',
      sizeVariant: 133,
      resSizeVariant: 75,
      top: '-55px',
      resTop: '5px',
      left: '0px',
      resLeft: '82%',
    },
    {
      type: 'tag',
      avatarUrl: `${connectedGuestListData.tagWeddingParty}?resize=w188&opt=aggressive`,
      sizeVariant: 192,
      resSizeVariant: 75,
      top: '-142px',
      resTop: '5px',
      left: '34px',
      resLeft: '82%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-1.jpg?resize=w147&opt=aggressive',
      sizeVariant: 151,
      resSizeVariant: 70,
      top: '-260px',
      resTop: '60px',
      left: '-330px',
      resLeft: '97%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-2.jpg?resize=w92&opt=aggressive',
      sizeVariant: 96,
      resSizeVariant: 100,
      top: '-135px',
      resTop: '0px',
      left: '275px',
      resLeft: '-100%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-24.jpg?resize=w152&opt=aggressive',
      sizeVariant: 156,
      resSizeVariant: 70,
      top: '16px',
      resTop: '60px',
      left: '211px',
      resLeft: '97%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-5.jpg?resize=w219&opt=aggressive',
      sizeVariant: 223,
      resSizeVariant: 75,
      top: '-90px',
      resTop: '125px',
      left: '-242px',
      resLeft: '85%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-7.jpg?resize=w170&opt=aggressive',
      sizeVariant: 174,
      resSizeVariant: 65,
      top: '150px',
      resTop: '240px',
      left: '-5px',
      resLeft: '70%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-5.jpg?resize=w87&opt=aggressive',
      sizeVariant: 91,
      resSizeVariant: 75,
      top: '170px',
      resTop: '125px',
      left: '-112px',
      resLeft: '85%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-1.jpg?resize=w147&opt=aggressive',
      sizeVariant: 151,
      resSizeVariant: 70,
      top: '-20px',
      resTop: '155px',
      left: '-475px',
      resLeft: '45%',
    },
    {
      type: 'avatar',
      avatarUrl: 'guest-list/hero-vid/avatars_photo_avatar-3.jpg?resize=w180&opt=aggressive',
      sizeVariant: 184,
      resSizeVariant: 85,
      top: '110px',
      resTop: '50px',
      left: '-317px',
      resLeft: '50%',
    },
  ];

  const {
    heroAnimationWrapperRef,
    lottieContainerRef,
    heroLottieRef,
    heroLoadAnimation,
    groupRef,
    groupLottieRef,
    groupLoadAnimation,
    organizeRef,
    organizeLottieRef,
    organizeLoadAnimation,
    inviteRef,
    inviteLottieRef,
    inviteLoadAnimation,
    trackRef,
    trackLottieRef,
    trackLoadAnimation,
    groupTopRef,
    groupBackRef,
    organizeTopRef,
    organizeBackRef,
    inviteTopRef,
    inviteBackRef,
    trackTopRef,
    trackBackRef,
    magneticAvatarClass,
    magneticAvatarLeftClass,
  } = useGuestListStaticHeroController();

  const animationSections = [
    {
      title: t('animationValueProps.group'),
      ref: groupRef,
      lottieRef: groupLottieRef,
    },
    {
      title: t('animationValueProps.organize'),
      ref: organizeRef,
      lottieRef: organizeLottieRef,
    },
    {
      title: t('animationValueProps.invite'),
      ref: inviteRef,
      lottieRef: inviteLottieRef,
    },
    {
      title: t('animationValueProps.track'),
      ref: trackRef,
      lottieRef: trackLottieRef,
    },
  ];

  const sideAssets = [
    {
      ref: groupBackRef,
      image: 'guest-list/hero-vid/art/group-bottom.svg',
    },
    {
      ref: groupTopRef,
      image: 'guest-list/hero-vid/art/group-top.svg',
    },
    {
      ref: organizeBackRef,
      image: 'guest-list/hero-vid/art/organize-bottom.svg',
    },
    {
      ref: organizeTopRef,
      image: 'guest-list/hero-vid/art/organize-top.svg',
    },
    {
      ref: inviteBackRef,
      image: 'guest-list/hero-vid/art/send-bottom.svg',
    },
    {
      ref: inviteTopRef,
      image: 'guest-list/hero-vid/art/send-top.svg',
    },
    {
      ref: trackBackRef,
      image: 'guest-list/hero-vid/art/collect-bottom.svg',
    },
    {
      ref: trackTopRef,
      image: 'guest-list/hero-vid/art/collect-top.svg',
    },
  ];

  return (
    <GuestListHeroSection id="Guest_List_Hero" marginX="auto" backgroundColor={'yellow1'}>
      <LazyLoadWrapper
        beforeLoad={() => {
          heroLoadAnimation();
          groupLoadAnimation();
          organizeLoadAnimation();
          inviteLoadAnimation();
          trackLoadAnimation();
        }}
      >
        <div />
      </LazyLoadWrapper>
      <Box paddingTop={[12, 14]} paddingBottom={7}>
        <StyledTextPairing
          title={connectedGuestListData.title}
          titleColor="neutra6"
          titleVariant="hed56"
          titleTagName="h1"
          body={connectedGuestListData.content}
          bodyColor="neutra5"
          bodyVariant="dek24"
          marginTop={[10, 4]}
          alignment="center"
        />
        <StyledBox marginTop={[0, 6]}>
          <Button id="ConnectedGuestList" variant="secondary" forwardedAs="a" href={getCreateWeddingUrl('guest-list')}>
            {connectedGuestListData.button}
          </Button>
        </StyledBox>
      </Box>
      <Box id="Hero_Animation_Wrapper" ref={heroAnimationWrapperRef}>
        <StyledAvatarsBox paddingTop={10}>
          <StyledLeftHeroBox>
            {heroTopAssetsLeft.map((heroTopAsset, index) => (
              <StyledHeroTopBox
                className={magneticAvatarLeftClass}
                key={index}
                isLeft={heroTopAsset.isLeft}
                top={heroTopAsset.top}
                offset={heroTopAsset.offset}
              >
                <StyledHeroTopCloudImage
                  src={heroTopAsset.image}
                  isMainSrcShown={true}
                  width={heroTopAsset.width}
                  height={heroTopAsset.height}
                  resizeWidth={heroTopAsset.width}
                  resizeHeight={heroTopAsset.height}
                  optimization="aggressive"
                />
              </StyledHeroTopBox>
            ))}
            {listItemAvatarLeft.map((avatar, index) => (
              <StyledLeftHeroAvatar key={index} top={avatar.top} left={avatar.left} className={magneticAvatarLeftClass}>
                <Avatar
                  src={avatar.avatarUrl}
                  strokeWidth={avatar.type == 'avatar' ? '2px' : '0px'}
                  strokeColor={'purple2'}
                  sizeVariant={avatar.sizeVariant + 'px'}
                />
              </StyledLeftHeroAvatar>
            ))}
          </StyledLeftHeroBox>
          <StyledRightHeroBox>
            {heroTopAssetsRight.map((heroTopAsset, index) => (
              <StyledHeroTopBox
                className={magneticAvatarClass}
                key={index}
                isLeft={heroTopAsset.isLeft}
                top={heroTopAsset.top}
                offset={heroTopAsset.offset}
              >
                <StyledHeroTopCloudImage
                  src={heroTopAsset.image}
                  isMainSrcShown={true}
                  width={heroTopAsset.width}
                  height={heroTopAsset.height}
                  resizeWidth={heroTopAsset.width}
                  resizeHeight={heroTopAsset.height}
                  optimization="aggressive"
                />
              </StyledHeroTopBox>
            ))}
            {listItemAvatarRight.map((avatar, index) => (
              <StyledRightHeroAvatar key={index} top={avatar.top} left={avatar.left} className={magneticAvatarClass}>
                <Avatar
                  src={avatar.avatarUrl}
                  strokeWidth={avatar.type == 'avatar' ? '2px' : '0px'}
                  strokeColor={'purple2'}
                  sizeVariant={avatar.sizeVariant + 'px'}
                />
              </StyledRightHeroAvatar>
            ))}
          </StyledRightHeroBox>
        </StyledAvatarsBox>
        <StyledLottieContainerBox>
          <StyledLottieBox id="Hero_Lottie_Container" ref={lottieContainerRef}>
            {animationSections.map((section, index) => (
              <StyledTextWrapper key={index} ref={section.ref} isInvite={index === 2}>
                <StyledIconBox ref={section.lottieRef} />
                <StyledText color="neutra6" variant="hed96Break" tagName="h2" textAlign={'left'}>
                  {ReactHtmlParser(section.title)}
                </StyledText>
              </StyledTextWrapper>
            ))}
            <Box ref={heroLottieRef} />
            {sideAssets.map((sideAsset, index) => (
              <StyledSideBox ref={sideAsset.ref} key={index}>
                <StyledSideCloudImage src={sideAsset.image} optimization="aggressive" />
              </StyledSideBox>
            ))}
          </StyledLottieBox>
        </StyledLottieContainerBox>
      </Box>
    </GuestListHeroSection>
  );
};
